import React, { useState } from "react";
import Slider from "react-slick";
import PDFCanvasViewer from "./PDFCanvasViewer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Journal.css"; // Ajout du CSS
import { pdfFiles } from "./Journaux";


function Journal() {
  const [selectedPdf, setSelectedPdf] = useState(pdfFiles[0].url); // PDF par défaut

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,  // S'assure qu'il y a toujours un élément centré
    slidesToScroll: 1,
    centerMode: true, // Active le centrage automatique
    focusOnSelect: true,
    centerPadding: "0px", // Supprime les marges internes pour un meilleur centrage
    responsive: [
      {
        breakpoint: 768, // Pour mobile et petits écrans
        settings: {
          slidesToShow: 1,
          centerMode: false, // Désactive le mode centre sur mobile
        }
      }
    ]
  };
  

  return (
    <div className="journal-container">
      <h4>Club Journal vous présente</h4>

      {/* Carrousel Slick */}
      <Slider {...settings} className="pdf-carousel">
        {pdfFiles.map((pdf, index) => (
          <div key={index} className={`pdf-item ${selectedPdf === pdf.url ? "active" : ""}`} onClick={() => setSelectedPdf(pdf.url)}>
            <img src={pdf.image} alt={pdf.name} className="pdf-thumbnail" />
            <p className="pdf-title">{pdf.name}</p>
          </div>
        ))}
      </Slider>

      {/* Affichage du PDF sélectionné */}
      <PDFCanvasViewer pdfUrl={selectedPdf} />
    </div>
  );
}

export default Journal;
